import { Fragment } from 'react';
import { Theme, useMediaQuery } from '@mui/material';
import { CoreTypography } from '@youscience/core';

import { BreadcrumbsLinks } from '@interfaces/location';

import { BRIGHTPATH_HOME_URL } from '@constants/externalRoutes';

import ChevronRightIcon from '@images/chevron-right.svg?react';
import ChevronLeftIcon from '@images/chevron-left.svg?react';

import { sxStyles, StyledBreadcrumbs, StyledHomeLink, StyledLink, StyledReadOnlyLink } from './Breadcrumbs.styles';

interface BreadcrumbsProps {
  links?: BreadcrumbsLinks[];
  currentPage?: string;
  readOnly?: boolean;
}

export const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { links, currentPage = '', readOnly = false } = props;

  const isMobileScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

  const mobileBreadcrumbs = links?.[links.length - 1];

  return (
    <StyledBreadcrumbs>
      {isMobileScreen && mobileBreadcrumbs ? (
        <StyledLink to={mobileBreadcrumbs.to}>
          <ChevronLeftIcon data-testid="chevronLeft" />

          {mobileBreadcrumbs.text}
        </StyledLink>
      ) : (
        <>
          <>
            {readOnly ? (
              <StyledReadOnlyLink data-testid="readOnlyHomeLink">Home</StyledReadOnlyLink>
            ) : (
              <StyledHomeLink data-testid="clickableHomeLink" href={BRIGHTPATH_HOME_URL} rel="noreferrer">
                Home
              </StyledHomeLink>
            )}
            <ChevronRightIcon />
          </>

          {links?.map((link) => (
            <Fragment key={`${link.to}-${link.text}`}>
              {readOnly ? (
                <StyledReadOnlyLink>{link.text}</StyledReadOnlyLink>
              ) : (
                <StyledLink to={link.to}>{link.text}</StyledLink>
              )}

              <ChevronRightIcon data-testid="chevronRight" />
            </Fragment>
          ))}

          <CoreTypography data-testid="currentPage" sx={sxStyles.currentPage} variant="body2" component="span">
            {currentPage}
          </CoreTypography>
        </>
      )}
    </StyledBreadcrumbs>
  );
};
